const ComorosSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111197)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9991 19.9414H18.3187C14.0142 24.2459 11.4112 27.5691 8.75342 30.227L20.0578 31.2457L37.5995 29.5066C39.1304 26.6788 39.9998 23.4406 39.9998 19.9993C39.9998 19.9799 39.9991 19.9608 39.9991 19.9414Z"
        fill="#D80027"
      />
      <path
        d="M8.75355 10.3769H37.5357C34.1343 4.19188 27.557 0 19.9999 0C14.4917 0 9.50449 2.22742 5.8877 5.83L8.75355 10.3769Z"
        fill="#FFDA44"
      />
      <path
        d="M9.62277 29.5078C7.82481 31.3058 7.12996 32.8122 5.8291 34.113C9.45059 37.7495 14.4619 40.0005 19.9996 40.0005C27.6039 40.0005 34.2168 35.7564 37.5993 29.5078H9.62277Z"
        fill="#0052B4"
      />
      <path
        d="M5.85785 5.79883C-1.95262 13.6093 -1.95262 26.2727 5.85785 34.0832C9.08543 30.8556 12.1896 27.7515 20 19.941L5.85785 5.79883Z"
        fill="#6DA544"
      />
      <path
        d="M5.27574 19.9414C5.27574 17.0275 7.32363 14.5932 10.0583 13.9961C9.63801 13.9043 9.20191 13.8545 8.75394 13.8545C5.39215 13.8545 2.66699 16.5796 2.66699 19.9414C2.66699 23.3032 5.39215 26.0284 8.75394 26.0284C9.20184 26.0284 9.63793 25.9786 10.0583 25.8868C7.32363 25.2896 5.27574 22.8554 5.27574 19.9414Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.99111 14.7246L10.3149 15.721H11.3626L10.5149 16.3369L10.8388 17.3333L9.99111 16.7175L9.14346 17.3333L9.46729 16.3369L8.61963 15.721H9.66728L9.99111 14.7246Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.99111 17.333L10.3149 18.3295H11.3626L10.5149 18.9453L10.8388 19.9418L9.99111 19.3259L9.14346 19.9418L9.46729 18.9453L8.61963 18.3295H9.66728L9.99111 17.333Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.99111 19.9414L10.3149 20.9378H11.3626L10.5149 21.5537L10.8388 22.5501L9.99111 21.9342L9.14346 22.5501L9.46729 21.5537L8.61963 20.9378H9.66728L9.99111 19.9414Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.99111 22.5518L10.3149 23.5482H11.3626L10.5149 24.164L10.8388 25.1604L9.99111 24.5446L9.14346 25.1604L9.46729 24.164L8.61963 23.5482H9.66728L9.99111 22.5518Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111197">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ComorosSvg;
